module.exports = __webpack_public_path__ + "static/img/dxf.f03605e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/dxf.png
// module id = F8++
// module chunks = 53